/**
 * Utility function to check approval status and determine visibility
 * @param {string} status - The current approval status
 * @param {Function} checkPermission - Function to check user permissions
 * @param {Function} setVisibility - Function to set approval visibility state
 */
export const checkStatusApproval = (status, checkPermission, setVisibility) => {
  const canSendForApproval = checkPermission('send for approval');
  const canApproveRealisasi = checkPermission('approve realisasi kpi korporat');

  if (!canSendForApproval && !canApproveRealisasi) {
    setVisibility(false);
  } else if (status === 'Menunggu Approval' && canSendForApproval) {
    setVisibility(false);
  } else if (status === 'Menunggu Approval' && canApproveRealisasi) {
    setVisibility(true);
  } else if (status === 'Approved') {
    setVisibility(false);
  } else {
    setVisibility(true);
  }
};
